window.addEventListener("load", () => globalThis.ret.initContentTooltips(".js-info-tooltip-init"));
